// 繁體中文
export default {
    common: {
        confirm: '確認',
        cancel: '取消',
        save: '保存',
        delete: '刪除',
        edit: '編輯',
        back: '返回',
        loading: '加載中...',
        error: '錯誤',
        success: '成功',
        warning: '警告',
        info: '信息',
        submit: '提交',
        close: '關閉',
        search: '搜索',
        more: '更多',
        empty: '暫無數據',
        yuan: '元'
    },

    nav: {
        home: '首頁',
        market: '行情',
        mall: '商城',
        mine: '我的',
        account: '賬戶'
    },

    login: {
        title: '登錄',
        account: '賬號',
        password: '密碼',
        code: '驗證碼',
        sendCode: '發送驗證碼',
        login: '登陸',
        register: '註冊',
        forgetPassword: '忘記密碼',
        accountRequired: '請輸入賬號',
        passwordRequired: '請輸入密碼',
        codeRequired: '請輸入驗證碼',
        noAccount: '還沒有賬號？',
        openAccount: '馬上開戶',
        contactService: '忘記密碼請聯繫客服！',
        loginSuccess: '登陸成功!',
        loginFailed: '登錄失敗',
        onlineService: '在線客服',
        forgetPasswordTip: '忘記密碼',
        username: '用戶名',
        recommendCode: '推薦碼',
        enterRecommendId: '請填寫推薦人ID'
    },

    index: {
        title: '首頁',
        quickRecharge: '快捷充值',
        rechargeDesc: '銀行轉賬和多種方式選擇',
        market: '交易',
        closed: '休市',
        welcome: '歡迎使用本平台！實時行情更新，安全便捷交易，祝您交易愉快！'
    },

    verified: {
        title: '實名認證',
        name: '姓名',
        idcard: '身份證號',
        nameError: '名字不正確',
        nameRequired: '請填寫姓名',
        idcardRequired: '請填寫身份證號',
        frontCardRequired: '請上傳身份證正面',
        backCardRequired: '請上傳身份證背面',
        submit: '確認',
        status0: '未認證',
        status1: '審核中',
        status2: '已認證'
    },

    user: {
        profile: '個人資料',
        account: '賬戶',
        settings: '設置',
        logout: '退出登錄',
        balance: '餘額',
        assets: '資產',
        history: '歷史記錄',
        myInfo: '我的信息',
        realName: '實名認證',
        bankCard: '銀行卡',
        alipay: '支付寶',
        phone: '手機號',
        email: '郵箱',
        name: '姓名'
    },

    trade: {
        title: '交易',
        buy: '買入',
        sell: '賣出',
        price: '價格',
        quantity: '數量',
        total: '總額',
        confirm: '確認交易',
        cancel: '取消交易',
        orderPlaced: '訂單已提交',
        orderFailed: '訂單提交失敗',
        insufficientBalance: '餘額不足',
        priceRequired: '請輸入價格',
        quantityRequired: '請輸入數量',
        volume: '成交量',
        highest: '最高',
        lowest: '最低',
        open: '今開',
        position: '持倉',
        kline: 'K線',
        fluctuation: '波動',
        time1m: '1分',
        time5m: '5分',
        time15m: '15分',
        time30m: '30分',
        time1h: '1小時',
        time1d: '一天',
        enterInvestAmount: '請輸入投資金額'
    },

    market: {
        title: '行情',
        price: '價格',
        change: '漲跌',
        volume: '成交量',
        high: '最高',
        low: '最低',
        open: '開盤',
        close: '收盤',
        upTrend: '上升',
        downTrend: '下降'
    },

    mall: {
        title: '商城',
        goods: '商品',
        cart: '購物車',
        order: '訂單',
        price: '價格',
        quantity: '數量',
        buy: '購買',
        addCart: '加入購物車',
        checkout: '結算',
        myOrders: '我的訂單'
    },

    recharge: {
        title: '充值',
        amount: '充值金額',
        method: '充值方式',
        bankTransfer: '銀行轉賬',
        alipay: '支付寶',
        wechat: '微信',
        rechargeSuccess: '充值成功',
        copied: '複製成功',
        copiedSuccess: '已複製',
        rechargeFailed: '充值失敗',
        amountRequired: '請輸入充值金額',
        methodRequired: '請選擇充值方式',
        rechargeRecord: '充值記錄'
    },

    cash: {
        title: '提現',
        amount: '提現金額',
        method: '提現方式',
        bankCard: '銀行卡',
        alipay: '支付寶',
        cashSuccess: '提現申請已提交',
        cashFailed: '提現失敗',
        amountRequired: '請輸入提現金額',
        methodRequired: '請選擇提現方式',
        cashRecord: '提現記錄',
        addBankCard: '添加銀行卡',
        addAlipay: '添加支付寶'
    },

    message: {
        title: '消息',
        noMessage: '暫無消息',
        markRead: '標記為已讀',
        delete: '刪除',
        news: '新聞',
        notification: '通知',
        system: '系統消息'
    },

    error: {
        networkError: '網絡錯誤',
        serverError: '服務器錯誤',
        notFound: '未找到',
        unauthorized: '未授權',
        forbidden: '禁止訪問',
        timeout: '請求超時',
        paramError: '參數錯誤',
        dataError: '數據錯誤',
        requestFailed: '請求失敗',
        networkErrorRetry: '網絡錯誤，請稍後重試'
    },

    account: {
        title: '賬戶',
        totalAssets: '總資產',
        availableBalance: '可用餘額',
        frozenBalance: '凍結餘額',
        tradingAccount: '交易賬戶',
        fundAccount: '資金賬戶',
        accountInfo: '賬戶信息',
        accountSecurity: '賬戶安全',
        changePassword: '修改密碼',
        oldPassword: '舊密碼',
        newPassword: '新密碼',
        confirmPassword: '確認密碼',
        passwordChanged: '密碼修改成功'
    },

    help: {
        title: '幫助中心',
        faq: '常見問題',
        tutorial: '使用教程',
        contact: '聯繫我們',
        feedback: '意見反饋',
        about: '關於我們',
        howRecharge: '如何充值？',
        rechargeAnswer: '請聯繫在線客服獲取充值信息',
        howWithdraw: '如何提現？',
        withdrawAnswer: '在賬戶頁面點擊提現申請，填寫相關信息即可',
        forgetPwd: '忘記密碼怎麼辦？',
        forgetPwdAnswer: '請聯繫在線客服協助找回密碼',
        modifyCard: '如何修改銀行卡？',
        modifyCardAnswer: '請聯繫在線客服協助修改銀行卡信息'
    },

    mine: {
        title: '我的',
        myInfo: '我的信息',
        realName: '實名認證',
        bankCard: '銀行卡',
        alipay: '支付寶',
        accountSecurity: '賬戶安全',
        logout: '退出登錄',
        creditScore: '信用積分',
        recommendCode: '推薦碼',
        level: '等級',
        copySuccess: '複製成功',
        phone: '手機號',
        name: '姓名',
        notVerified: '未認證',
        verifying: '審核中',
        verified: '已認證',
        news: '新聞資訊',
        passwordModify: '密碼修改',
        bindingInfo: '綁定信息',
        onlineService: '在線客服',
        tradingRules: '交易規則',
        aboutUs: '關於我們',
        recommendIdCopied: '推薦ID已複製',
        notObtained: '未獲取'
    },

    rechargeDetail: {
        title: '充值',
        tip: '溫馨提示：點擊收款賬號和姓名可複製其內容',
        bankName: '開戶銀行',
        bankBranch: '開戶網點',
        accountNumber: '收款賬號',
        accountName: '收款姓名',
        contactService: '聯繫在線客服',
        amount: '充值金額',
        depositorName: '存款姓名',
        transferRemark: '轉賬附言',
        submit: '充值',
        copied: '已複製'
    },

    cashDetail: {
        title: '提現',
        availableAmount: '可提現金額（元）',
        withdrawAmount: '提現金額',
        fee: '手續費',
        minAmount: '單次提現金額最低',
        password: '提現密碼',
        bankCard: '提現賬戶',
        submit: '確認提交',
        hint: '提示',
        limit: '提現限制',
        time: '提現時間',
        forgetPwd: '若忘記提現密碼，請',
        retrieve: '點擊找回',
        record: '提現記錄',
        withdrawal: '提現',
        pending: '審核中',
        rejected: '已拒絕',
        completed: '已到賬',
        arrived: '已到賬',
        refused: '已拒絕',
        reviewing: '審核中'
    },

    bankCard: {
        title: '銀行卡管理',
        addBank: '添加銀行卡',
        bindAlipay: '綁定支付寶',
        bindWallet: '綁定錢包地址',
        walletAddress: '錢包地址',
        walletSection: '錢包地址',
        enterWalletAddress: '請輸入錢包地址',
        cardholderName: '持卡人',
        cardNumber: '銀行卡號',
        bankName: '開戶銀行',
        bankBranch: '開戶支行',
        submit: '確認添加',
        realName: '真實姓名',
        alipayAccount: '支付寶賬號',
        bindSubmit: '確認綁定',
        alipaySection: '支付寶賬號',
        enterCardholderName: '請輸入持卡人姓名',
        enterCardNumber: '請輸入銀行卡號',
        enterBankName: '請輸入開戶銀行',
        enterRealName: '請輸入真實姓名',
        enterAlipayAccount: '請輸入支付寶賬號',
        contactService: '修改銀行卡請聯繫在線客服'
    },

    password: {
        modifyLogin: '修改登錄密碼',
        modifyPay: '修改支付密碼',
        oldPassword: '原密碼',
        newPassword: '新密碼',
        confirmPassword: '確認密碼',
        payPassword: '支付密碼',
        confirmPayPassword: '確認支付密碼',
        submit: '確認修改',
        enterOldPwd: '請輸入原密碼',
        enterNewPwd: '請輸入新密碼',
        enterConfirmPwd: '請再次輸入新密碼',
        passwordMismatch: '兩次密碼不一致'
    },

    bill: {
        title: '賬單',
        fundChange: '資金變動',
        noRecord: '暫無記錄',
        income: '收入',
        expense: '支出'
    },

    news: {
        title: '新聞資訊',
        detail: '新聞詳情',
        noNews: '暫無新聞',
        tradeRules: '交易規則',
        aboutUs: '關於我們'
    },

    tradeDetail: {
        buyRise: '買漲',
        buyFall: '買跌',
        highest: '最高',
        lowest: '最低',
        open: '今開',
        position: '持倉',
        volume: '成交量',
        kline: 'K線',
        fluctuation: '波動',
        time1m: '1分',
        time5m: '5分',
        time15m: '15分',
        time30m: '30分',
        time1h: '1小時',
        timeDay: '一天'
    },

    service: {
        title: '在線客服',
        contactService: '聯繫客服',
        anyQuestion: '如有任何問題，請聯繫在線客服'
    },

    landing: {
        onlineAccount: '網上開戶',
        spotGoods: '現貨商品',
        contactService: '聯繫客服',
        personalCenter: '個人中心',
        characteristicService: '特色服務',
        characteristicServiceEn: 'CHARACTERISTIC SERVICE'
    },

    accountDetail: {
        title: '我的賬戶',
        totalAssets: '賬戶總資產',
        profitLoss: '賬戶盈虧',
        position: '持倉金額',
        availableFunds: '可用資金',
        refresh: '刷新',
        rechargeRecord: '充值記錄',
        rechargeApply: '充值申請',
        withdrawApply: '提現申請',
        currentEntrust: '當前委託',
        historyEntrust: '歷史委託',
        bill: '賬單',
        bankCardManage: '銀行卡管理',
        accountSecurity: '賬戶安全'
    },

    historyEntrust: {
        title: '歷史委託',
        noRecord: '暫無記錄',
        buyRise: '買漲',
        buyFall: '買跌'
    },

    settings: {
        accountSecurity: '賬戶安全',
        username: '用戶名',
        modifyLoginPwd: '修改登錄密碼',
        modifyPayPwd: '修改支付密碼'
    }
}
